import { HelpOutline, UploadOutlined } from '@mui/icons-material';
import { Box, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import {
  deleteAPI,
  ListWrapper,
  SahinDataTable,
  SahinButton,
} from '@sahinyazilim/sahinyazilim-components';
import { AdminTablePaths } from 'common/model/AdminTablePaths';
import { uploadAPI } from 'common/helper/apiHelpers';
import { useFetch } from 'common/hooks/useFetchSwr';
import { mutate } from 'swr';
import { useState, useRef } from 'react';
import { File } from '../models/File';
import { fileListColumns } from './FileList.types';

export const FileList = () => {
  const { data } = useFetch<File[]>(AdminTablePaths.FILES);
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setIsUploading(true);
    try {
      const uploaded = await uploadAPI(AdminTablePaths.BRAND, file);

      if (uploaded) {
        mutate(AdminTablePaths.FILES);
      }
    } catch (error: any) {
      console.error('Dosya yükleme hatası:', error);
    } finally {
      setIsUploading(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const handleDelete = (data: File) => {
    deleteAPI(AdminTablePaths.FILES, data.id).then(() => {
      mutate(AdminTablePaths.FILES);
    });
  };

  return (
    <ListWrapper
      title="Yüklenen Dosyalar"
      infoComponent={
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
          sx={{ width: '100%' }}
        >
          <Grid item>
            <Tooltip
              title={
                <Box>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.5, fontWeight: 'bold' }}
                  >
                    Yüklenen Dosyalar Sayfası
                  </Typography>
                  <Typography variant="body2">
                    Bu sayfada yüklediğiniz tüm dosyaları yönetebilirsiniz.
                    Dosyalarınızı silebilir, boyutlarını ve yükleme tarihlerini
                    kontrol edebilirsiniz. Yüklenen dosyaları kategori ve
                    ürünlerinizde kullanılabilirsiniz
                  </Typography>
                </Box>
              }
              arrow
            >
              <IconButton size="small" color="info">
                <HelpOutline />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item>
            <SahinButton
              variant="contained"
              startIcon={<UploadOutlined />}
              onClick={handleUploadClick}
              disabled={isUploading}
            >
              {isUploading ? 'Yükleniyor...' : 'Dosya Yükle'}
            </SahinButton>
          </Grid>
        </Grid>
      }
    >
      <input
        ref={fileInputRef}
        type="file"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <SahinDataTable
        data={data || []}
        columns={fileListColumns as any}
        onDelete={handleDelete}
        emptyDataMessage="Yüklenen dosya bulunamadı"
      />
    </ListWrapper>
  );
};
